var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.copyTextDialog,
        "append-to-body": true,
        "before-close": _vm.cleanData,
      },
      on: {
        "update:visible": function ($event) {
          _vm.copyTextDialog = $event
        },
      },
    },
    [
      _c(
        "div",
        [
          !_vm.copiedText
            ? _c("el-alert", { attrs: { type: "warning" } }, [
                _vm._v("\n      Click in the input to copy\n    "),
              ])
            : _c("el-alert", { attrs: { type: "success" } }, [
                _vm._v("\n      Text copied!\n    "),
              ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm.enableInput
            ? _c(
                "div",
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 15, readonly: true },
                    on: { focus: _vm.selectAndCopy },
                    model: {
                      value: _vm.copyContentData,
                      callback: function ($$v) {
                        _vm.copyContentData = $$v
                      },
                      expression: "copyContentData",
                    },
                  }),
                ],
                1
              )
            : _c("div", [_vm._v("\n      Loading information...\n    ")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.copyTextDialog = false
                },
              },
            },
            [_vm._v("Close")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }